import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'
import { Login, Token } from 'types/api'
import { BaseParams } from 'types/utils'

export function useLogin() {
  const onError = useOnError()

  async function login({ body }: BaseParams<[Login, Token], 'POST'>) {
    const res = await apiClient.post<Token>(`${SNA_PREFIX}auth/login`, body)
    return res.data
  }

  return useMutation({
    mutationFn: login,
    onSuccess: (data, variables) => {
      variables?.params?.onSuccess?.(data)
    },
    onError
  })
}
